const app = {
  state: {
    date: {
      time: '',
      isCurMonth: true
    },
    isAndroid: false,
    routeInfo: '{}',
    selectVal: [], // 下拉组件需要记录的值
    abnormal: false // 是否有异常
  },
  mutations: {
    TOGGLE_DATE: (state, date) => {
      state.date = date
    },
    TOGGLE_ISANDROID: (state, isAndroid) => {
      state.isAndroid = isAndroid
    },
    TOGGLE_ROUTE: (state, routeInfo) => {
      state.routeInfo = routeInfo
    },
    setSearchWord (state, chooseItem) {
      const { key, mapValue, mapLabel, isDate, time } = chooseItem
      const values = isDate ? time : chooseItem[mapValue]
      const label = chooseItem[mapLabel]
      let flag = state.selectVal.find(item => {
        if (item.type === key) {
          item['values'] = values
          item['label'] = label
        }
        return item.type === key
      })
      if (!flag) {
        state.selectVal.push({
          type: key,
          values,
          label
        })
      }
    },
    setAbnormal (state, flag) {
      state.abnormal = flag
    }
  },
  actions: {
    toggleDate ({ commit }, date) {
      commit('TOGGLE_DATE', date)
    },
    toggleIisAndroid ({ commit }, isAndroid) {
      commit('TOGGLE_ISANDROID', isAndroid)
    },
    toggleRoute ({ commit }, routeInfo) {
      commit('TOGGLE_ROUTE', routeInfo)
    },
    // 下拉选择查询
    async searchKanBanData ({ commit }, data) {
      return new Promise(resolve => {
        commit('setSearchWord', data)
        resolve()
      })
    }
  }
}

export default app
